var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "render-item_image" }, [
    _c("div", { staticClass: "render-image_label" }, [
      _vm._v(_vm._s(_vm.labelName))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "render-image_content" },
      _vm._l(_vm.currentModelProxy, function(item, indexs) {
        return _c("el-image", {
          key: indexs,
          attrs: {
            "preview-src-list": _vm.currentModelProxy,
            src: _vm.currentModelProxy[indexs],
            "show-viewer": _vm.show[indexs],
            index: _vm.index
          },
          on: {
            close: function($event) {
              return _vm.close(indexs)
            },
            open: function($event) {
              return _vm.open(indexs)
            }
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34fb80f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34fb80f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/render_item/RenderImage.vue
// module id = null
// module chunks = 